import { CryptoToken } from 'src/app/shared/entities/crypto-token';
import { createGridDataFeature } from '../../../shared/store/grid-data/create-grid-data-feature';
import { createDrilldownFeature } from '../../../shared/store/drilldown/create-drilldown-feature';

function isCryptotokenlistUrl(url: string): boolean {
  return url === '/cryptotokenlist' || url.startsWith('/cryptotokenlist?');
}

export const {
  feature: cryptotokenlistFeature,
  actions: CryptotokenlistDataActions,
  createEffects: createCryptotokenlistDataEffects,
} = createGridDataFeature<'Crypto Token List Data', CryptoToken>(
  'Crypto Token List Data',
  {
    routeFilter: route => isCryptotokenlistUrl(route.url),
  },
);

export const {
  feature: cryptotokenlistDrilldownFeature,
  actions: CryptotokenlistDrilldownActions,
  createEffects: createCryptotokenlistDrilldownEffects,
} = createDrilldownFeature<'Crypto Token List Drilldown'>(
  'Crypto Token List Drilldown',
  {
    routeFilter: route => isCryptotokenlistUrl(route.url),
  },
);

export const CryptotokenlistActions = {
  ...CryptotokenlistDataActions,
  ...CryptotokenlistDrilldownActions,
  // ...CryptotokenlistEditActions,
};

export const { selectGridData: selectCryptotokenlistGridData } =
  cryptotokenlistFeature;
export const { selectDrilldownKey: selectCryptotokenlistDrilldownKey } =
  cryptotokenlistDrilldownFeature;
